/**
 * User: tendlich
 *
 * Responsible for the ticket tab
 */
define(function (require) {
    "use strict";
    var LE = require("app");

    var TicketSearchController = require("connection-controllers/ticketTab/TicketSearchController");
    var TicketViewController = require("connection-controllers/ticketTab/TicketViewController");
    var TicketExtendedListViewController = require("connection-controllers/ticketTab/TicketExtendedListViewController");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");

    var TicketsCollection = require("connection-collections/ticketTab/TicketsCollection");
    var TicketsSnippetsCompositeModel = require("connection-models/ticketTab/TicketsSnippetsCompositeModel");
    var TicketModel = require("connection-models/ticketTab/TicketModel");
    var AccountInfoModel = require("connection-models/ticketTab/AccountInfoModel");

    var TicketTabLayout = require("connection-views/layouts/ticketTab/TicketTabLayout");
    var TicketsListView = require("connection-views/ticketTab/TicketsListView");
    var TicketHeaderView = require("connection-views/ticketTab/TicketHeaderView");

    var CP_CONST = require("connection-const");

    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");

    var PAGE_SIZE = 10;
    var TicketTabController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        TicketTabController = Marionette.Controller.extend({
            referrerAction: "ticketTab",

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.isCreateCaseVisible = options.isCreateCaseVisible;
                this.ticketTabLayout = new TicketTabLayout(options);
                this.tickets = this._initTicketsCollection();
                this.accountModel = new AccountInfoModel();
                this.locked = false;
                this._initializeChannels();
                this._bindEvents();//bind events before creating controller otherwise error!
                this._createControllers();
                this._renderTicketTabLayout();
                LEConnection.logger.debug("TicketTabController.initialize: successfully initialized the TicketTabController");
            },

            _initTicketsCollection: function(){
                //organize and change the type of collection to selectableCollection decorator otherwise the paging on extended list wont work
                //since we are using extra collections for closed and open tickets -> no problems with that
                var decorateOptions = {
                    pageSize: PAGE_SIZE,
                    lazy: true
                };
                var tickets = new TicketsCollection(null,{viewOnly:false});
                tickets = SelectableCollectionDecorator.decorate(tickets);
                tickets = OrganizeCollectionDecorator.decorate(tickets,decorateOptions);
                LEConnection.logger.debug("TicketTabController._initTicketsCollection: successfully initialized the TicketsCollection");
                return tickets;
            },

            _initializeChannels: function(){
                this.channel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);
                this.contentContainerChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.CONTENT_CONTAINER);
                this.ticketViewControllerChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_VIEW);
                this.usageTrackingChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.USAGE_TRACKING);
                LEConnection.logger.debug("TicketTabController._initializeChannels: successfully initialized TicketTab events channels");
            },

            _createControllers: function(){
                this.ticketExtendedListViewController = new TicketExtendedListViewController({
                    connectionPanelContextModel: this.connectionPanelContextModel,
                    contentContainerChannel : this.contentContainerChannel,
                    usageTrackingChannel: this.usageTrackingChannel,
                    ticketsCollection: this.tickets,
                    isCreateCaseVisible: this.isCreateCaseVisible
                    }
                );
                this.ticketsearchController = new TicketSearchController({
                    connectionPanelContextModel: this.connectionPanelContextModel,
                    ticketsCollection: this.tickets,
                    channel : this.channel
                });
                this.ticketViewController = new TicketViewController({
                    connectionPanelContextModel: this.connectionPanelContextModel,
                    channel: this.channel,
                    containerChannel : this.contentContainerChannel,
                    ticketsCollection: this.tickets
                });
                LEConnection.logger.debug("TicketTabController._createControllers: successfully created all controllers");
            },

            _bindEvents: function () {
                //listen once to init the view with the collection if the tab is clicked
                this.listenTo(LEConnection.vent, "TicketTabController::initCollection", _.bind(this._onInitCollection,this));
                this.ticketTabLayout.on("render", this._onTicketTabLayoutRendered, this);
                this.listenTo(this.channel.vent,"TicketTabController::refetch",this._refetchTickets);
                this.listenTo(this.channel.vent,"TicketTabController::ticket:display",this._displayTicketView);
                this.listenTo(this.channel.vent,"TicketTabController::createTicket:display",this._displayCreateTicketView);
                this.listenTo(this.channel.vent,"show:extendedList", this._showExtendedList);
                this.listenTo(this.channel.vent,"container:close",this._closeExtendedList);
                this.listenTo(this.channel.vent,"TicketTabController::ticketView:close",this._closeTicketView);
                this.listenTo(this.channel.vent,"TicketTabController::track:usage",this._usageTrack);
                this.listenTo(this.connectionPanelContextModel, "change:selectedTicket", this._changeSelectedTicket);
                this.listenTo(this.channel.vent,"TicketTabController::showRegion:searchInputRegion", this._showSearchInputRegion);
                this.listenTo(this.channel.vent,"TicketTabController::add:ticket",this._addTicketModel);
                LEConnection.logger.debug("TicketTabController._bindEvents: successfully binded all events");
            },

            _renderTicketTabLayout: function(){
                LEConnection.vent.trigger("MainContainerController::showRegion:ticketRegion", {
                    view: this.ticketTabLayout
                });
            },

            _onInitCollection: function(){
                if(!this.locked){
                    this.locked = true;
                    this._getTicketsCollection();
                    if(!this._checkIfSalesForceIdExists()){
                        this._getAccountModel();
                    }
                }
            },

            _addTicketModel: function(model){
                this.tickets.getOriginalCollection().add(model,{at:0});
                this._applyFilter();
                LEConnection.logger.debug("TicketTabController._addTicketModel: successfully added ticketModel "+model);
            },

            _getAccountModel: function(){
                var self = this;
                var errorMsg = LE.translator.translate("LEFramework.errors.serverError.1100");
                this.accountModel.fetch({
                    success: function(){
                        self.connectionPanelContextModel.setSalesForceId(self.accountModel.getSalesForceId());
                        self.connectionPanelContextModel.setAccountName(self.accountModel.getAccountName());
                        self.connectionPanelContextModel.setCanAddSeverity(self.accountModel.canAddSeverity());
                        LEConnection.logger.debug("TicketTabController._getAccountModel: success loading AccountModel for this account");
                    },
                    error:function(){
                        LEConnection.notifier.showError(errorMsg);
                        LEConnection.logger.error("TicketTabController._getAccountModel: failed to load AccountModel for this account");
                        LEConnection.logger.graph({name:"connection:TicketTabController:couldNotLoadAccountInfoModel"});
                    }});

            },

            _getTicketsCollection: function () {
                this._setLoader();
                this.tickets.fetch({
                    success: _.bind(function () {
                        this._applyFilter();
                        this.locked = false;
                        this._closeLoader();
                        this.connectionPanelContextModel.set("ticketsCollection",this.tickets);
                        LEConnection.logger.debug("TicketTabController._getAccountModel: success loading AccountModel for this account");
                    }, this),
                    error:_.bind(function(){
                        this._closeLoader();
                        this.locked = false;
                        LEConnection.notifier.showError(LE.translator.translate("LEFramework.errors.serverError.1100"));
                        LEConnection.logger.error("TicketTabController._getTicketsCollection: failed to load TicketsCollection for this account");
                        LEConnection.logger.graph({name:"connection:TicketTabController:couldNotLoadTicketsCollection"});
                    },this)
                });
            },

            _refetchTickets: function(){
                this.tickets.fetch();
            },

            _onTicketTabLayoutRendered: function () {
                this._showRegion(this.ticketTabLayout.headerDetailedRegion, new TicketHeaderView({
                    context:this.connectionPanelContextModel,
                    isCreateCaseVisible: this.isCreateCaseVisible
                }));
                this._setLoader();
            },

            _applyFilter: function(){
                this.tickets.filterByClose();
                //todo create one class to save and render both, closed and open tickets
                this.ticketsListViewClosed = new TicketsListView({
                    collection: this.tickets.getClosedTicket(),
                    model: new TicketsSnippetsCompositeModel({listTitle: LE.translator.translate("LEConnection.cases.ticketTab.recentlyOpenedCases").toUpperCase()})
                });
                this._showRegion(this.ticketTabLayout.recentRegion, this.ticketsListViewClosed);
                this.ticketsListViewOpen = new TicketsListView({
                    collection: this.tickets.getOpenTicket(),
                    model: new TicketsSnippetsCompositeModel({listTitle: LE.translator.translate("LEConnection.cases.ticketTab.recentlyClosedCases").toUpperCase()})
                });
                this._showRegion(this.ticketTabLayout.closedRegion, this.ticketsListViewOpen);
                this.ticketListViewClosedWithBugs = new TicketsListView({
                    collection: this.tickets.getClosedTicketsWithBugs(),
                    model: new TicketsSnippetsCompositeModel({listTitle: LE.translator.translate('LEConnection.cases.ticketTab.recentlyClosedCasesWithBug').toUpperCase()})
                });
                this._showRegion(this.ticketTabLayout.closedBugsRegion, this.ticketListViewClosedWithBugs);
            },

            _displayTicketView: function (options) {
                this._setTicketAsTopElement();
                var previousTicket = this._getSelectedTicket();
                var currentTicket = (options) ? options.model : null;
                if(previousTicket && currentTicket && (previousTicket.getId() === currentTicket.getId())){
                    currentTicket = null;
                    this._closeTicketView();
                }else{
                    if(!_.isNull(currentTicket)){
                        this._setSelectedTicket(currentTicket);
                        this.fromExtendedView = options.fromExtendedView || false;
                        this._setExtendedViewIsOpen(false);
                        this.ticketViewControllerChannel.vent.trigger("TicketViewController::ticket:display",options);
                        //USAGE TRACKING
                        if(this.fromExtendedView){
                            this._usageTrack({
                                slug: currentTicket.getId(),
                                usageToTrack:CP_CONST.USAGE_TO_TRACK.MYCASES.OPEN_ONE_CASE_FROM_EXTENDED
                            });
                        }else{
                            this._usageTrack({
                                slug: currentTicket.getId(),
                                usageToTrack:CP_CONST.USAGE_TO_TRACK.MYCASES.OPEN_ONE_CASE
                            });
                        }
                    }
                }
            },

            _displayCreateTicketView: function(options){
                this._setTicketAsTopElement();
                if(this._checkIfSalesForceIdExists()&&this.isCreateCaseVisible){
                    this._setSelectedTicket(null);
                    this._setExtendedViewIsOpen(false);
                    this.ticketViewControllerChannel.vent.trigger("TicketViewController::createTicket:display",options);
                }else{
                    LEConnection.notifier.showInfo(LE.translator.translate("LEConnection.cases.ticketTab.createCaseDataNotAvailable"));
                }
            },

            _checkIfSalesForceIdExists: function(){
                return !_.isNull(this.connectionPanelContextModel.getSalesForceId());
            },

            _closeTicketView: function(){
                this._closeContentContainer();
                this._setSelectedTicket(null);
            },

            _closeExtendedList: function(){
                this._setExtendedViewIsOpen(false);
                this._closeContentContainer();
            },

            _closeContentContainer: function(){
                this.contentContainerChannel.vent.trigger("TicketExtendedContainerController::container:close");
            },

            _showExtendedList: function () {
                if(!this.connectionPanelContextModel.isTicketListOpen()){
                    this._setTicketAsTopElement();
                    this._setSelectedTicket(null);
                    this.ticketExtendedListViewController.show(this.tickets);
                    this._setExtendedViewIsOpen(true);
                    this._usageTrack({
                        slug:"User opened extended list view",
                        usageToTrack:CP_CONST.USAGE_TO_TRACK.MYCASES.OPEN_EXTENDED
                    });
                }else{
                    this._closeExtendedList();
                }
            },

            _showSearchInputRegion: function (options) {
                if (options && options.view) {
                    this._showRegion(this.ticketTabLayout.searchInputRegion, options.view);
                }
            },

            _setTicketAsTopElement: function () {
                this.connectionPanelContextModel.setTopElement(CP_CONST.PAGE.TICKET);
            },

            _showRegion: function (region, view) { //??
                if (this.ticketTabLayout.getIsRendered()) {
                    region.show(view);
                }
                else {
                    this.listenTo(this.ticketTabLayout, "render", function () {
                        region.show(view);
                    });
                }
            },

            _changeSelectedTicket: function (model, selectedTicket) {
                if (this.ticketsListViewOpen&&this.ticketsListViewClosed&&this.ticketListViewClosedWithBugs) {
                    var id = (selectedTicket) ? selectedTicket.get("id") : "";
                    this.ticketsListViewOpen.setSelected(id);
                    this.ticketsListViewClosed.setSelected(id);
                    this.ticketListViewClosedWithBugs.setSelected(id);
                }
            },

            _usageTrack: function(options){
                this.usageTrackingChannel.vent.trigger("UsageTrackingController:track",options);
            },

            _setExtendedViewIsOpen: function(value){
                this.connectionPanelContextModel.setTicketListIsOpen(value);
            },

            _getSelectedTicket: function(){
                return this.connectionPanelContextModel.getSelectedTicket();
            },

            _setSelectedTicket: function(model){
                this.connectionPanelContextModel.setSelectedTicket(model);
            },

            _setLoader: function () {
                this.ticketTabLayout.setLoader();
            },

            _closeLoader: function () {
                this.ticketTabLayout.closeLoader();
            },

            _hideRegions:function(){
                this.ticketTabLayout.hideRegions();
            },

            _showRegions:function(){
                this.ticketTabLayout.showRegions();
            }

        });
    });
    return TicketTabController;
});


